module.exports = "//cdn-staging.livechat-static.com/webapp/img/automation/One-icon-active.png?baf567723a1fabf88898a88b8a44daf5";